import React, { useContext } from 'react';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconFooterLogo({
  isAutoscallable = true,
  extColor,
  onClick,
  style,
  sizeKey = '32x32',
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill={extColor}
    >
      <path d="M14.3199 9.43662C15.2029 9.43662 15.9093 8.73022 15.9093 7.84722C15.9093 6.96421 15.2029 6.25781 14.3199 6.25781C13.4369 6.25781 12.7305 6.96421 12.7305 7.84722C12.7305 8.73022 13.4369 9.43662 14.3199 9.43662Z" />
      <path d="M13.7902 13.616L17.2634 12.2621V10.7315L15.6151 10.084H13.0838L11.4355 10.7315V15.4997L12.8484 16.1473L13.3193 21.0921H15.3796L15.5562 19.3261C13.437 16.9714 13.7902 13.616 13.7902 13.616Z" />
      <path d="M14.1435 13.8521C14.1435 14.7939 14.2024 18.5025 17.2634 20.2685C20.3834 18.5025 20.4422 14.7939 20.3834 13.8521L17.2634 12.6747L14.1435 13.8521ZM17.2634 21.0927L17.0868 20.9749C12.9661 18.738 13.3782 13.7932 13.4371 13.5577V13.3223L17.2634 11.8506L21.0898 13.3223V13.5577C21.0898 13.7343 21.5607 18.738 17.44 20.9749L17.2634 21.0927Z" />
      <path d="M26.7411 13.734C26.7411 7.6118 21.7963 2.66699 15.733 2.66699C9.66969 2.66699 4.66602 7.6118 4.66602 13.6751C4.66602 16.6184 5.84335 19.444 7.90369 21.5044C8.25689 21.8576 8.78669 21.8576 9.19876 21.5632C9.37536 21.3866 9.49309 21.1512 9.49309 20.9157C9.49309 20.6802 9.37536 20.4448 9.19876 20.2682C5.60789 16.6773 5.60789 10.7906 9.19876 7.19974C12.7896 3.60886 18.6763 3.60886 22.2672 7.19974C25.8581 10.7906 25.8581 16.6773 22.2672 20.2682L14.4379 28.0386L15.733 29.3337L23.5034 21.5044C25.5637 19.444 26.7411 16.6773 26.7411 13.734Z" />
    </svg>
  );
}
